// "How to send a test webhook" instructions, keyed by BACKEND PROCESSOR.

// Extra setup needed for Stripe Payment Links / Hosted / Embedded Checkout
export const STRIPE_CHECKOUT_DOC_URL =
  'https://visiopt.zendesk.com/hc/en-us/articles/53386057931547-Stripe-Adding-the-Checkout-Session-ID-to-Your-Success-URL';

export interface WebhookTestStep {
  text: string;
  image?: string;
  // Display name + icon, so consumers don't have to map the processor themselves
  label?: string;
  logo?: string;
}

export const WEBHOOK_TEST_STEP: Record<string, WebhookTestStep> = {
  youform: {
    text: 'Open your Youform form → Integrate → Webhooks and click "Send test" to fire a sample event to Visiopt.',
    image: 'img/webhook-setup/youform/test.png',
    label: 'Youform',
    logo: 'img/cart-icons/youform.png',
  },
  ultracart: {
    text: 'Open Advanced → Developer Tools → Webhooks and click "test" button to fire a sample event to Visiopt.',
    image: 'img/webhook-setup/ultracart/test.png',
    label: 'UltraCart',
    logo: 'img/cart-icons/ultracart.png',
  },
  shopify: {
    text: 'Log in to Shopify and go to → settings → Notifications → Webhooks → Select (...) on webhook and click "Send test" to fire a sample event to Visiopt.',
    image: 'img/webhook-setup/shopify/test.png',
    label: 'Shopify',
    logo: 'img/cart-icons/shopify.png',
  },
  typeform: {
    text: 'Open your Typeform form → Connect → Webhooks, click the View deliveries button, then click Send test request to fire a sample event to Visiopt.',
    image: 'img/webhook-setup/typeform/test.png',
    label: 'Typeform',
    logo: 'img/cart-icons/typeform.png',
  },
  hubspot: {
    text: 'Log in to your HubSpot account and navigate to Development → Legacy Apps → select your legacy app → Webhooks. Hover over your webhook, click View details, then click Test to fire a sample event to Visiopt.',
    image: 'img/webhook-setup/hubspot/test.png',
    label: 'HubSpot',
    logo: 'img/cart-icons/hubspot.png',
  },
  digistore24: {
    text: 'Log in to your Digistore24 account and navigate to Settings → Integrations (IPN) Configuration → edit your webhook → scroll down and click Test Connection to fire a sample event to Visiopt.',
    image: 'img/webhook-setup/digistore24/test.png',
    label: 'Digistore24',
    logo: 'img/cart-icons/digistore24.png',
  },
  chargebee: {
    text: 'Log in to Chargebee and go to Settings → Configure Chargebee → Webhooks, then click Test webhook to fire a sample event to Visiopt.',
    image: 'img/webhook-setup/chargebee/test.png',
    label: 'Chargebee',
    logo: 'img/cart-icons/chargebee.png',
  },
};

// Test-webhook step for a processor (undefined when the platform has no test feature)
export const webhookTestStep = (processor: string): WebhookTestStep | undefined =>
  WEBHOOK_TEST_STEP[processor];

// True when the processor supports firing a test event
export const webhookSupportsTest = (processor: string): boolean =>
  Boolean(WEBHOOK_TEST_STEP[processor]);
